import { LogManager, bindable } from 'aurelia-framework';
//import { NodeModel } from 'aurelia-tree-view';
import { TreeViewItem } from '../../../core/tree-view-item';
import { ITreeViewItem } from '../../../core/itree-view-item';
import { NodeAspect } from "../../../core/node-aspect";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-dependency-injection';
import { AppEvents } from "core/app-events";
import searchTree from 'core/searchTree';


@autoinject()
export class TreeView {

	dragItemEndSubscription: Subscription;
	dragItemStartSubscription: Subscription;
    @bindable item: TreeViewItem = {} as TreeViewItem;
    @bindable save:Function;
    @bindable changed;

    @bindable selectedItem;
	logger = LogManager.getLogger('TreeView');

    constructor(private eventAggregator: EventAggregator)
    {
  
	}

	attached() {
		this.logger.info("attached");
		this.dragItemStartSubscription = this.eventAggregator.subscribe(AppEvents.DRAG_ITEM_START, (payload) => this.dragItemStart(payload));
		this.dragItemEndSubscription = this.eventAggregator.subscribe(AppEvents.DRAG_ITEM_END, (payload) => this.dragItemEnd(payload));

	}

	detached() {
		this.logger.info('detached');
		this.dragItemStartSubscription.dispose();
		this.dragItemEndSubscription.dispose();
	}

	

	dragItemStart(item) {
		this.logger.info("dragItemStart" + item.id);
		let treeViewItem = searchTree(this.item, item.id);
		this.dragItem = treeViewItem;
	}

	dragItemEnd(item) {
		this.dragItem = null;
	}


    showContextMenu(e, item) {
		
        this.eventAggregator.publish(AppEvents.SHOW_TOP_LEVEL_LIST_CONTEXT_MENU, [e, item]);
        
    }

    onMouseOver(item) {
        item.nodeAspect.isHovering = true;
    }

    onMouseOut(item) {
        item.nodeAspect.isHovering = false;
    }

    wrapItem(item: TreeViewItem) {
        this.addNodeAspect(item, false);
    }

    selectedItemChanged(newValue: TreeViewItem, oldValue: TreeViewItem) {
		this.logger.info('selectedItemChanged()');
        this.updateSelectedItemHighlight(newValue, oldValue);
        //this.publishSelectedItemChangedEvent(newValue, oldValue);
        
    }

    publishSelectedItemChangedEvent(newValue: TreeViewItem, oldValue: TreeViewItem) {
        this.eventAggregator.publish(AppEvents.SELECTED_ITEM_CHANGED, { newValue: newValue, oldValue: oldValue });
    }

    updateSelectedItemHighlight(newValue: TreeViewItem, oldValue: TreeViewItem)
    {
        if (oldValue && oldValue.nodeAspect) oldValue.nodeAspect.isSelected = false;
        if (newValue && newValue.nodeAspect) newValue.nodeAspect.isSelected = true;
    }


    //callOnSelectedItemChanged(item) {
    //    this.changed({ selectedItem: item });
    //}


	handleKeyPress(event, item) {
		
		if (event.keyCode === 13) {
			this.logger.info("Handling KeyPress Event keyCode === 13")
            this.saveEdit(item);
        }
     }

	//This is here to prevent the browser from refreshing when Enter is pressed when editing the TreeView Item.
	preventDefault(item) {
		this.logger.info("preventDefault()");
		item.nodeAspect.isEditing = false;
	}

    nodeSelected(item) {
        this.selectedItem = item;
        this.publishSelectedItemChangedEvent(item, null);
        
    }

	saveEdit(item: TreeViewItem) {
		this.logger.info('saveEdit()')
        item.nodeAspect.isEditing = false;
        this.callSave(item);
    }

    //This is calling the bound save which requires a special syntax.
	callSave(item: TreeViewItem) {
		this.logger.info('callSave()')
        this.save({ itemToSave: item });
    }

    itemChanged(newValue: TreeViewItem, oldValue: TreeViewItem) {
        if (newValue) {
            this.validateChildItems(newValue);
            this.addEvent(newValue);
            this.addNodeAspect(newValue, true);
        }
    }

    validateChildItems(item: TreeViewItem) {
        if (!item.children) return;
        item.children.forEach(
            (i) => {
                if (!i.parent) {
                    throw new Error(`Treeview Structure Validation Error: ${i.name} does not have a parent.`);
                }
                if (i.items) {
                    this.validateChildItems(i);
                }
            }
        );
    }

    addNodeAspect(item: TreeViewItem, isExpanded:boolean) {
        item.nodeAspect = new NodeAspect(isExpanded);
        if (!item.children) return;
        item.children.forEach(
            (i) => {
                this.addNodeAspect(i, false);
            }
        );
    }

    addEvent(myArray) {
        (myArray as any[]).push = (...args: any[]): number => {
            (Array.prototype.push as any).apply(myArray, args);
            this.onAddItem(args);
            return myArray.length;
        };


    }

    onAddItem(items: any[]) {

        if (Array.isArray(items)) {

            items.forEach(
                (i) => {
                    this.addNodeAspect(i,false);
                });
        } else {
            this.addNodeAspect(items as TreeViewItem, false);
        }
    }



    dragItem: TreeViewItem;

    dragStart(event, item) {
        try {
            if (item) {
                this.dragItem = item;
                return true;
            }
        } catch (ex) {
            this.logger.error("dragStart Exception was caught:" + ex.message);
        }
    }

    processDrop(newParent: TreeViewItem, child: any) {

        try {
				child.nodeAspect.isHovering = false;//Remove the highlight.
                child.parent.children._remove(child);
                newParent.children.push(child);
                child.parentId = newParent.id;
            child.parent = newParent;
			this.callSave(child);
        } catch (ex) {
            console.log("processDrop Exception was caught:" + ex.message);
        }


    }

    drop(event, parent) {
        if (!parent) {
            throw new Error("Parent item not passed to drop event");
        }
        

        if (this.dragItem) {
            let child = this.dragItem;

            if (!child.parent) throw new Error("drop event exception was caught: child.parent is null");

			//This happens when the child is the same as the parent.  Do not process.
			if (child.id === parent.id) return;
            this.dragItem = null;
            this.processDrop(parent, child);
        } else {
            throw new Error("cannot process drop if dragItem is null");
        }
    }

    dragOver(event, item) {
        if (item) {
            this.logger.info("onDragOver");
            event.preventDefault();
        }
    }



    inputOnBlur(item) {
        item.nodeAspect.isEditing = false;
        
    }

    nodeDoubleClick(item) {
        item.nodeAspect.isEditing = true;
    }

    

    

    


    toggleItems(item: TreeViewItem) {
        item.nodeAspect.isExpanded = !item.nodeAspect.isExpanded;
    }
    

}